export default __webpack_public_path__ + "static/media/Human5.c0f749c6.png";